export default {
      id: "attention-Red-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#attention-Red",
      toString: function () {
        return this.url;
      }
    }